/* ICONS */
import { MdOutlineSpaceDashboard, MdContactSupport, MdMedicalServices } from "react-icons/md";
import { RiRefreshLine, RiArrowLeftRightLine, RiSettings3Line } from "react-icons/ri";
import { TbRepeat } from "react-icons/tb";

const navMenu = [
  {
    id: 1,
    link: "/dashboard",
    icon: MdOutlineSpaceDashboard,
    name: "Dashboard",
  },
  {
    id: 2,
    link: "/contact-requests",
    icon: MdContactSupport,
    name: "Contact Requests",
  },
  {
    id: 3,
    link: "/refill-requests",
    icon: RiRefreshLine,
    name: "Refill Requests",
  },
  {
    id: 4,
    link: "/transfer-requests",
    icon: RiArrowLeftRightLine,
    name: "Transfer Requests",
  },
  {
    id: 5,
    link: "/auto-rx-requests",
    icon: TbRepeat,
    name: "Auto Rx Enrollments",
  },
  {
    id: 6,
    link: "/services",
    icon: MdMedicalServices,
    name: "Services",
  },
  {
    id: 7,
    link: "/site-settings",
    icon: RiSettings3Line,
    name: "Site Settings",
  },
];

export default navMenu;
